import { Box, Image } from "@chakra-ui/react";
import React from "react";

const Home = () => {
  return (
    <Box>
      <Image
       height={"550px"}
       width={"100%"}
        src="https://images.unsplash.com/photo-1518843875459-f738682238a6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1442&q=80"
        alt=""
      />
    </Box>
  );
};

export default Home;
